import template from './update-accounts.html';
import { intersection } from 'lodash-es';
import { actions, selectors } from '../../../state';
import { STATES } from '../../../constants';
import { CATEGORIES } from './categories';
import './update-accounts.global.css';

const VERIFIED_MESSAGE = `You've been verified and we're now submitting your updates
  to each organization. Some updates may take longer than others, but you can always
  check the status here.`;

class UpdateAccountsController {
  constructor(updStore) {
    'ngInject';
    Object.assign(this, {
      updStore,
      categories: CATEGORIES,
      searchSref: STATES.STEP_UPDATE_ACCOUNTS_SEARCH,
    });
  }

  $onInit() {
    const { connect, dispatch, getState } = this.updStore;
    this.disconnect = connect(mapStateToThis)(this);
    dispatch(actions.step.isTerminalRoute());

    if (selectors.router.currentParamsVerified(getState())) {
      dispatch(actions.message.success(VERIFIED_MESSAGE));
    }
  }

  $onDestroy() {
    this.disconnect();
  }

  get headerTitle() {
    return this.hasItems
      ? `Let's Add Some More Accounts`
      : 'Select Which Accounts You Want To Update';
  }

  onNameIdChange(nameId) {
    this.updStore.dispatch(actions.name.setSelectedId(nameId));
  }

  onCancel(item) {
    const { dispatch } = this.updStore;

    const success = () => {
      dispatch(
        actions.message.success(
          `Cancelled. We've cancelled that account update.`
        )
      );
      dispatch(actions.analytics.track('Cancelled UYA', { id: item.id }));
    };

    const error = response => {
      dispatch(
        actions.message.error(
          `Sorry, there was an error cancelling. Please try again.`
        )
      );
      dispatch(actions.analytics.track('Tried to Cancel UYA', { response }));
    };

    dispatch(actions.item.singleton(item.id).destroy()).then(success, error);
  }
}

export const UpdateAccountsComponent = {
  template,
  controller: UpdateAccountsController,
};

function mapStateToThis(state) {
  const { current, name } = selectors;
  const nameId = name.selectedId(state);
  const items = current.updateAccountItems(state).map(mapItem(state));
  const filteredItemByNameId = items.filter(item => item.nameId === nameId);

  return {
    userID: current.user(state).id(state),
    moveDate: selectors.current.move(state).date(state),
    hasItems: current.hasUpdateAccountItems(state),
    itemsByCategory: reduceCategoriesAndItems(filteredItemByNameId),
    items,
    nameId,
  };
}

function mapItem(state) {
  return item => {
    const org = item.organization(state);

    return {
      id: item.id(state),
      nameId: item.nameId(state),
      status: item.status(state),
      statusUpdatedAt: item.statusUpdatedAt(state),
      state: item.state(state),
      categories: org.categories(state).map(category => category.name(state)),
      organization: {
        name: org.name(state),
      },
    };
  };
}

function reduceCategoriesAndItems(items) {
  return CATEGORIES.reduce((ret, category) => {
    ret[category.name] = items.filter(item =>
      isIntersection(item.categories, category.categories)
    );
    return ret;
  }, {});
}

function isIntersection(list1, list2) {
  return !!intersection(list1, list2).length;
}
